<template>
  <div
    v-if="isLoading"
    class="d-flex justify-center align-center"
    style="height: 100vh; width: 100vw;"
  >
    <v-progress-circular
      indeterminate
      color="#2661FF"
      size="80"
    ></v-progress-circular>
  </div>
  <div v-else>
    <v-row no-gutters>
      <v-col cols="12">
        <BaseToolbar
          :title="$t('pricing_model.edit.pricing_model.title').toUpperCase()"
          type-title="icon"
          icon="edit_square"
          :button-save="false"
          @close="closeEditPricingModel"
        >
        </BaseToolbar>
      </v-col>
    </v-row>
    <v-row class="pa-8">
      <v-col cols="12">
        <v-card class="rounded-lg pa-4" flat>
          <v-card-title class="justify-center">
            {{ $t('pricing_model.edit.pricing_model.title') }}
          </v-card-title>
          <v-card-text class="text-center grey--text text--darken-3 mb-2">
            {{ $t('pricing_model.edit.pricing_model.description') }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <!------------------------------------------>
                <!-- NAME ----------------------------->
                <!------------------------------------------>
                <v-col cols="12" md="6">
                  <!-- <h3 class="body-2 mb-2 ml-1">
                    {{ $t("pricing_model.edit.pricing_model.name") }}
                  </h3> -->
                  <v-text-field
                    v-model="localPricingModel.display_name"
                    :rules="rules.name"
                    label="Nombre"
                    class="rounded-lg"
                    hide-details
                    outlined
                    required
                  >
                  </v-text-field>
                </v-col>
                <!------------------------------------------>
                <!-- ID ----------------------------->
                <!------------------------------------------>
                <v-col cols="12" md="6">
                  <!-- <h3 class="body-2 mb-2 ml-1">
                    {{ $t("pricing_model.edit.pricing_model.id") }}
                  </h3> -->
                  <v-text-field
                    v-model="localPricingModel.id"
                    disabled
                    label="ID"
                    class="rounded-lg"
                    hide-details
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <!------------------------------------------>
                <!-- DESCRIPTION ----------------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <!-- <h3 class="body-2 mb-2 ml-1">
                    {{
                      $t(
                        "pricing_model.edit.pricing_model.description_input.title"
                      )
                    }}
                  </h3> -->
                  <v-text-field
                    v-model="localPricingModel.description"
                    :rules="rules.description"
                    :label="
                      $t(
                        'pricing_model.edit.pricing_model.description_input.label'
                      )
                    "
                    class="rounded-lg"
                    hide-details
                    outlined
                    required
                  >
                  </v-text-field>
                </v-col>
                <!------------------------------------------>
                <!-- STATUS ----------------------------->
                <!------------------------------------------>
                <v-col cols="12" md="6">
                  <!-- <h3 class="body-2 mb-2 ml-1">
                    {{ $t("pricing_model.edit.pricing_model.status") }}
                  </h3> -->
                  <v-select
                    v-model="localPricingModel.status"
                    :items="status"
                    :label="$t('pricing_model.edit.pricing_model.status')"
                    class="rounded-lg"
                    hide-details
                    outlined
                    required
                  >
                  </v-select>
                </v-col>
                <!------------------------------------------>
                <!-- FREQUENCY ----------------------------->
                <!------------------------------------------>
                <v-col cols="12" md="6">
                  <!-- <h3 class="body-2 mb-2 ml-1">
                    {{ $t("pricing_model.edit.pricing_model.frequency") }}
                  </h3> -->
                  <v-select
                    v-model="localPricingModel.frequency"
                    :items="frequencies"
                    disabled
                    :label="$t('pricing_model.edit.pricing_model.frequency')"
                    class="rounded-lg"
                    hide-details
                    outlined
                    required
                  >
                  </v-select>
                </v-col>
                <!------------------------------------------>
                <!-- CURRENCIES ----------------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <!-- <h3 class="body-2 mb-2 ml-1">
                    {{ $t("pricing_model.edit.pricing_model.currencies") }}
                  </h3> -->
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      v-for="currency in localPricingModel.currencies"
                      class="mb-2"
                    >
                      <v-card
                        class="rounded-r-lg"
                        style="border-left: 4px solid #2661ff !important;"
                      >
                        <v-card-title
                          class="subtitle-1 grey--text text--darken-3"
                        >
                          <v-icon class="mr-2" color="#2661FF">payments</v-icon>
                          <span>
                            {{ currency.name }}
                            ({{ currency.code }})
                          </span>
                        </v-card-title>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-btn
                        class="rounded-lg mt-4"
                        color="#2661FF"
                        @click="togleAddCurrencyDialog"
                      >
                        <v-icon color="white">
                          add
                        </v-icon>
                        <span style="color: white;">
                          {{ $t('pricing_model.edit.add_currency.title') }}
                        </span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="d-flex justify-end" style="gap: 16px;">
                  <v-btn class="rounded-lg" color="#999" @click="reset">
                    <span style="color: white;">{{ $t('actions.clean') }}</span>
                  </v-btn>
                  <v-btn
                    class="rounded-lg"
                    color="#2661FF"
                    @click="save"
                    :loading="isUpdateLoading"
                    :disabled="noChanges"
                  >
                    <span style="color: white;">{{ $t('actions.save') }}</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="py-2 px-8" no-gutters>
      <v-col cols="12">
        <v-expansion-panels>
          <!------------------------------------------>
          <!-- PLANS --------------------------------->
          <!------------------------------------------>
          <v-expansion-panel class="custom_card my-2">
            <v-expansion-panel-header>
              <span class="text_color text-subtitle-2">
                Planes
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-expansion-panels>
                <EditPlan
                  v-for="(plan, i) in localPricingModel.plans"
                  :key="i"
                  :plan="plan"
                  class="rounded-lg my-2"
                  @update-plan="updatePlanInList"
                />
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!------------------------------------------>
          <!-- SERVICES ------------------------------>
          <!------------------------------------------>
          <v-expansion-panel class="custom_card my-2">
            <v-expansion-panel-header>
              <span class="text_color text-subtitle-2">
                Servicios
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-expansion-panels>
                <EditService
                  v-for="(service, i) in localPricingModel.services"
                  :key="i"
                  :service="service"
                  class="rounded-lg my-2"
                  @update-service="updateServiceInList"
                />
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <AddCurrency
      v-if="addCurrencyDialog && Object.keys(pricingModel).length > 0"
      :display="addCurrencyDialog"
      @close-dialog="togleAddCurrencyDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar'
import EditPlan from '@/components/PricingModels/Edit/EditPlan'
import AddCurrency from '@/components/PricingModels/Edit/AddCurrency/AddCurrency'
import EditService from './EditService.vue'

export default {
  name: 'PricingModelEdit',
  components: {
    EditPlan,
    BaseToolbar,
    EditService,
    AddCurrency
  },
  data () {
    return {
      isLoading: false,
      isUpdateLoading: false,
      addCurrencyDialog: false,
      valid: true,
      rules: {
        name: [
          v => !!v || this.$t('pricing_model.edit.pricing_model.rules.name')
        ],
        description: [
          v =>
            (!!v && v.length > 10) ||
            this.$t('pricing_model.edit.pricing_model.rules.description')
        ]
      },
      status: [
        {
          text: this.$t('pricing_model.edit.pricing_model.statuses.active'),
          value: true
        },
        {
          text: this.$t('pricing_model.edit.pricing_model.statuses.disabled'),
          value: false
        }
      ],
      frequencies: [
        {
          text: this.$t('pricing_model.edit.pricing_model.frequencies.monthly'),
          value: 1
        },
        {
          text: this.$t('pricing_model.edit.pricing_model.frequencies.yearly'),
          value: 2
        },
        {
          text: this.$t(
            'pricing_model.edit.pricing_model.frequencies.monthly_and_yearly'
          ),
          value: 3
        }
      ],
      localPricingModel: {}
    }
  },
  created () {
    this.localPricingModel = { ...this.pricingModel }
  },
  watch: {
    pricingModel () {
      this.localPricingModel = { ...this.pricingModel }
    }
  },
  computed: {
    ...mapState({
      pricingModel: ({ pricingModels: { pricingModel } }) => pricingModel
    }),
    noChanges () {
      const pricingModelKeys = Object.keys(this.pricingModel)
      return pricingModelKeys.every(key => {
        const pricingModelValue = this.pricingModel[key]
        const localPricingModelValue = this.localPricingModel[key]
        return this.isEqual(pricingModelValue, localPricingModelValue)
      })
    }
  },
  methods: {
    ...mapActions({
      updatePricingModel: 'pricingModels/updatePricingModel'
    }),
    ...mapMutations({
      setPricingModelDrawerEdit: 'pricingModels/setPricingModelDrawerEdit',
      resetPricingModel: 'pricingModels/resetPricingModel'
    }),
    isEqual (a, b) {
      if (a === b) return true
      if (typeof a !== 'object' || typeof b !== 'object') return false
      const keysA = Object.keys(a)
      const keysB = Object.keys(b)
      if (keysA.length !== keysB.length) return false
      for (const key of keysA) {
        if (!keysB.includes(key) || !this.isEqual(a[key], b[key])) return false
      }
      return true
    },
    closeEditPricingModel () {
      this.setPricingModelDrawerEdit(false)
      this.resetPricingModel()
    },
    validate () {
      return this.$refs.form.validate()
    },
    async reset () {
      this.localPricingModel = this.pricingModel
    },
    async save () {
      if (this.validate()) {
        try {
          this.isUpdateLoading = true

          await this.updatePricingModel(this.localPricingModel)
        } catch (error) {
        } finally {
          this.isUpdateLoading = false
        }
      }
    },
    async updatePlanInList (updatedPlan) {
      // Find and update the plan in your plans array
      const updatedPlans = this.localPricingModel.plans.map(plan => {
        if (plan.id === updatedPlan.id) {
          return { ...plan, ...updatedPlan }
        } else {
          return plan
        }
      })

      // Update the plans array in localPricingModel
      this.localPricingModel.plans = updatedPlans
    },
    async updateServiceInList (updatedService) {
      // Find and update the service in your services array
      const updatedServices = this.localPricingModel.services.map(service => {
        if (service.id === updatedService.id) {
          return { ...service, ...updatedService }
        } else {
          return service
        }
      })

      // Update the services array in localPricingModel
      this.localPricingModel.services = updatedServices
    },
    togleAddCurrencyDialog () {
      this.addCurrencyDialog = !this.addCurrencyDialog
    }
  }
}
</script>

<style lang="scss">
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}
.text_color {
  color: #344054 !important;
}
</style>
